export default __webpack_public_path__ + "static/media/msk_rpe_up.0c70fcca.svg";